export enum SecurityTabs {
  Captcha = 'captcha',
  PasswordPolicy = 'password-policy',
  General = 'general',
}
